import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 17.17L18.83 16H4V4h16v13.17zM20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2z"
}), 'ModeCommentOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ModeCommentOutlined.js
// module id = 4872
// module chunks = 2